// extracted by css-extract-rspack-plugin
export default {"round-tabs":"LeHmFQ9r","round-tabs__tab":"kz_RHXhs","round-tabs__tab--active":"ull2_P_U"};